// ============================================================
// PARCELAMENTO — lê data-attributes do snippet custom-installment
// Sem script inline no snippet para evitar renderização como texto
// ============================================================
(function() {
  function initInstallments() {
    document.querySelectorAll('.custom-parcels').forEach(function(el) {
      var productValue = Number(el.dataset.price) / 100;
      var parcels      = Number(el.dataset.parcelas);
      var feeTax       = Number(el.dataset.juros);
      var minParcel    = Number(el.dataset.valParcela);
      var optJuros     = el.dataset.opcaoJuros;
      var hasTax       = optJuros !== 'sem_juros';
      var startTax     = Number(el.dataset.startJuros);

      var feeTaxDecimal = feeTax / 100;
      var qtdParcelView = 0;
      var viewParcel;
      var labelText = '';

      for (var i = 1; i <= parcels; i++) {
        var parcelValue;
        if (hasTax && i >= startTax) {
          parcelValue = (productValue * feeTaxDecimal) / (1 - Math.pow(1 + feeTaxDecimal, -i));
        } else {
          parcelValue = productValue / i;
        }
        if (parcelValue < minParcel) break;
        viewParcel    = parcelValue;
        qtdParcelView = i;
        labelText     = (hasTax && i >= startTax) ? 'com juros' : 'sem juros';
      }

      if (qtdParcelView > 1) {
        el.textContent = 'ou ' + qtdParcelView + 'x de R$ ' +
          viewParcel.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) +
          ' ' + labelText;
        el.style.display = 'block';
      }
    });
  }

  document.addEventListener('DOMContentLoaded', initInstallments);
})();

// ============================================================
// CALCULADOR DE FRETE — handler via delegação no custom.js
// Funciona em qualquer contexto: PDP, quickview, modal
// ============================================================
(function() {
  function calcConvertToReal(value) {
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value);
  }

  function calcRemoveProduct(variantId) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 0 })
    });
  }

  function calcSetLoading(btn, loading) {
    var loader = btn.parentElement ? btn.parentElement.querySelector('.custom-shipping-calc-loader') : null;
    if (loading) {
      btn.style.display = 'none';
      if (loader) loader.style.display = 'inline-flex';
    } else {
      btn.style.display = '';
      if (loader) loader.style.display = 'none';
    }
  }

  function calcShipping(btn, zipCode, variantId) {
    var parent = btn.closest('.custom-shipping-calculator');
    var country = 'Brazil';
    var province = '';
    var ufMap = {
      AC:'Acre', AL:'Alagoas', AM:'Amazonas', AP:'Amapá', BA:'Bahia',
      CE:'Ceará', DF:'Distrito Federal', ES:'Espírito Santo', GO:'Goiás',
      MA:'Maranhão', MG:'Minas Gerais', MS:'Mato Grosso do Sul', MT:'Mato Grosso',
      PA:'Pará', PB:'Paraíba', PE:'Pernambuco', PI:'Piauí', PR:'Paraná',
      RJ:'Rio de Janeiro', RN:'Rio Grande do Norte', RO:'Rondônia', RR:'Roraima',
      RS:'Rio Grande do Sul', SC:'Santa Catarina', SE:'Sergipe', SP:'São Paulo',
      TO:'Tocantíns'
    };

    calcSetLoading(btn, true);
    parent.classList.add('loading');

    fetch('//viacep.com.br/ws/' + zipCode + '/json')
      .then(function(r) { return r.json(); })
      .then(function(data) {
        if (data.erro) {
          alert('CEP não encontrado.');
          parent.classList.remove('loading'); calcSetLoading(btn, false);
          return;
        }
        province = ufMap[data.uf ? data.uf.toUpperCase() : ''] || '';
        if (!province) {
          alert('Estado não identificado.');
          parent.classList.remove('loading'); calcSetLoading(btn, false);
          return;
        }

        fetch('/cart/shipping_rates.json?shipping_address[zip]=' + zipCode +
              '&shipping_address[country]=' + country +
              '&shipping_address[province]=' + encodeURIComponent(province))
          .then(function(r) { return r.json(); })
          .then(function(data) {
            var rates = data.shipping_rates || [];
            var ratesContainer = parent.querySelector('.shipping-rates');
            ratesContainer.innerHTML = '<p><strong>' +
              (rates.length > 1 ? 'Existem ' + rates.length + ' tipos de fretes disponíveis.' :
               rates.length === 1 ? 'Existe 1 tipo de frete disponível.' :
               'Nenhuma opção de frete encontrada.') +
              '</strong></p>';
            rates.forEach(function(rate) {
              var days = rate.delivery_days && rate.delivery_days[0];
              var printDays = days > 0 ? ' - ' + days + (days === 1 ? ' dia útil' : ' dias úteis') : '';
              var printPrice = rate.price > 0 ? calcConvertToReal(rate.price) : 'Grátis';
              var li = document.createElement('li');
              li.innerHTML = '<strong>' + rate.name + '</strong> - ' + printPrice + printDays;
              ratesContainer.appendChild(li);
            });
            parent.classList.remove('loading'); calcSetLoading(btn, false);
            // Remover produto APÓS receber a resposta
            if (variantId) calcRemoveProduct(variantId);
          })
          .catch(function() {
            alert('Erro ao calcular frete. Tente novamente.');
            parent.classList.remove('loading'); calcSetLoading(btn, false);
            if (variantId) calcRemoveProduct(variantId);
          });
      })
      .catch(function() {
        alert('CEP inválido. Verifique e tente novamente.');
        parent.classList.remove('loading'); calcSetLoading(btn, false);
      });
  }

  // Máscara de CEP sem biblioteca externa
  document.addEventListener('input', function(e) {
    if (!e.target.classList.contains('custom_zip_code')) return;
    var v = e.target.value.replace(/\D/g, '').substring(0, 8);
    e.target.value = v.length > 5 ? v.substring(0, 5) + '-' + v.substring(5) : v;
  }, true);

  // Delegação de clique — funciona para PDP e quickview
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.custom_shipping_button');
    if (!btn) return;

    var parent = btn.closest('.custom-shipping-calculator');
    if (!parent) return;

    var zipCode = (parent.querySelector('.custom_zip_code') || {}).value || '';
    zipCode = zipCode.replace(/\D/g, '');

    if (zipCode.length !== 8) {
      alert('Digite um CEP válido (8 dígitos).');
      return;
    }

    var isProduct = parent.getAttribute('data-template') === 'product';

    if (!isProduct) {
      calcShipping(btn, zipCode, null);
      return;
    }

    // Página de produto: busca o input de variante pelo seletor do tema
    var productFormEl = parent.closest('product-form') || document.querySelector('product-form');
    var variantInput = productFormEl
      ? productFormEl.querySelector('input.product-variant-id, input[name="id"]')
      : document.querySelector('input.product-variant-id');
    var variantId = variantInput ? variantInput.value : null;

    if (!variantId) {
      alert('Variante não identificada.');
      return;
    }

    calcSetLoading(btn, true);
    parent.classList.add('loading');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
    .then(function(r) { return r.json(); })
    .then(function() { calcShipping(btn, zipCode, variantId); })
    .catch(function() {
      parent.classList.remove('loading'); calcSetLoading(btn, false);
      alert('Não foi possível calcular o frete. Tente novamente.');
    });
  });
})();
